module.exports = __webpack_public_path__ + "fa-regular-400.35307505c129ab1f9173.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-regular-400.ttf
// module id = ./src/assets/webfonts/fa-regular-400.ttf
// module chunks = styles